import React from "react";
import { Modal, Spin } from "antd";
import { UiButton } from "../../../../components";
import "./style.scss";

const BankDetailsModal = ({
    open,
    onClose,
    bankDetails,
    loading = false
}) => {
    let bankList = [];
    if (Array.isArray(bankDetails)) {
        bankList = bankDetails;
    } else if (Array.isArray(bankDetails?.bankDetails)) {
        bankList = bankDetails.bankDetails;
    } else if (Array.isArray(bankDetails?.lawyerDetailResponse?.bankDetails)) {
        bankList = bankDetails.lawyerDetailResponse.bankDetails;
    } else if (bankDetails && typeof bankDetails === 'object') {
        const single = bankDetails?.bankDetails || bankDetails;
        if (single && typeof single === 'object') {
            bankList = [single];
        }
    }

    const activeBank = bankList.find(b => Boolean(b?.primary)) || bankList[0] || {};
    const accountHolderName = activeBank?.accountHolderName || "Nil";
    const accountNumber = activeBank?.decryptAccountNumber || activeBank?.accountNumber || activeBank?.accountNo || "Nil";
    const bankName = activeBank?.bankName || "Nil";
    const branchName = activeBank?.branchName || "Nil";
    const ifscCode = activeBank?.ifsc || activeBank?.ifscCode || "Nil";
    const accountType = activeBank?.accountType || "";
    const isPrimary = Boolean(activeBank?.primary);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={480}
            centered
            className="bank-details-modal"
            title={
                <div className="bank-modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", paddingRight: "24px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span className="bank-modal-title">Bank Details</span>
                    </div>
                    {isPrimary && (
                        <span style={{
                            fontSize: "11px",
                            backgroundColor: "#52c41a",
                            color: "#fff",
                            padding: "2px 8px",
                            borderRadius: "10px",
                            fontWeight: 600
                        }}>
                            Primary Account
                        </span>
                    )}
                </div>
            }
        >
            <div className="bank-modal-content">
                {loading ? (
                    <div className="bank-modal-loader">
                        <Spin spinning={loading} />
                    </div>
                ) : (
                    <>
                        <div className="bank-details-grid">
                            <div className="bank-detail-item">
                                <span className="bank-detail-label">Account Holder Name</span>
                                <span className="bank-detail-value">{accountHolderName}</span>
                            </div>
                            <div className="bank-detail-item">
                                <span className="bank-detail-label">Account No</span>
                                <span className="bank-detail-value">{accountNumber}</span>
                            </div>
                            <div className="bank-detail-item">
                                <span className="bank-detail-label">Bank Name</span>
                                <span className="bank-detail-value">{bankName}</span>
                            </div>
                            <div className="bank-detail-item">
                                <span className="bank-detail-label">Branch Name</span>
                                <span className="bank-detail-value">{branchName}</span>
                            </div>
                            <div className="bank-detail-item">
                                <span className="bank-detail-label">IFSC Code</span>
                                <span className="bank-detail-value">{ifscCode}</span>
                            </div>
                            {accountType && (
                                <div className="bank-detail-item">
                                    <span className="bank-detail-label">Account Type</span>
                                    <span className="bank-detail-value">{accountType}</span>
                                </div>
                            )}
                            {(bankDetails?.upiIds || activeBank?.upiIds || activeBank?.upiId) && (
                                <div className="bank-detail-item">
                                    <span className="bank-detail-label">UPI ID</span>
                                    <span className="bank-detail-value">
                                        {Array.isArray(bankDetails?.upiIds || activeBank?.upiIds)
                                            ? (bankDetails?.upiIds || activeBank?.upiIds).map(u => typeof u === "string" ? u : (u?.upiId || u?.id || "")).filter(Boolean).join(", ")
                                            : String(bankDetails?.upiIds || activeBank?.upiIds || activeBank?.upiId || "Nil")}
                                    </span>
                                </div>
                            )}
                        </div>
                    </>
                )}
                <div className="bank-modal-footer">
                    <UiButton onClick={onClose} type="primary">
                        Close
                    </UiButton>
                </div>
            </div>
        </Modal>
    );
};

export default BankDetailsModal;
